import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import caskMasterService from "../services/caskMasterService";

// Add CaskMaster Start
const addCaskMasterDataState = {
  addCaskMasterLoading: false,
  addCaskMasterData: null,
  addCaskMasterError: null,
};

const addCaskMasterData = createAsyncThunk(
  "caskmaster/addcaskmaster",
  async (payload) => {
    return await caskMasterService.createCaskMaster(payload);
  },
);

const addCaskMasterReducer = createSlice({
  name: "addCaskMaster",
  initialState: addCaskMasterDataState,
  extraReducers: (builder) => {
    builder.addCase(addCaskMasterData.pending, (state) => {
      state.addCaskMasterLoading = true;
    });
    builder.addCase(addCaskMasterData.fulfilled, (state, action) => {
      state.addCaskMasterLoading = false;
      state.addCaskMasterData = action.payload;
      state.addCaskMasterError = "";
    });
    builder.addCase(addCaskMasterData.rejected, (state, action) => {
      state.addCaskMasterLoading = false;
      state.addCaskMasterData = null;
      state.addCaskMasterError = action.error.message;
    });
  },
});

export const AddCaskMasterReducer = addCaskMasterReducer.reducer;
export const AddCaskMasterData = addCaskMasterData;
// Add CaskMaster End

// Update CaskMaster By Id Start
const updateCaskMasterState = {
  updateCaskMasterLoading: false,
  updateCaskMasterData: null,
  updateCaskMasterError: null,
};

const updateCaskMasterData = createAsyncThunk(
  "caskmaster/updateCaskMaster",
  async (payload) => {
    return await caskMasterService.updateCaskMaster(payload);
  },
);

const updateCaskMasterReducer = createSlice({
  name: "updateCaskMasterData",
  initialState: updateCaskMasterState,
  extraReducers: (builder) => {
    builder.addCase(updateCaskMasterData.pending, (state) => {
      state.updateCaskMasterLoading = true;
    });
    builder.addCase(updateCaskMasterData.fulfilled, (state, action) => {
      state.updateCaskMasterLoading = false;
      state.updateCaskMasterData = action.payload;
      state.updateCaskMasterError = "";
    });
    builder.addCase(updateCaskMasterData.rejected, (state, action) => {
      state.updateCaskMasterLoading = false;
      state.updateCaskMasterData = null;
      state.updateCaskMasterError = action.error.message;
    });
  },
});

export const UpdateCaskMasterReducer = updateCaskMasterReducer.reducer;
export const UpdateCaskMasterData = updateCaskMasterData;
// Update CaskMaster End

// Get CaskMaster List Start
const getCaskMasterListState = {
  getCaskMasterListLoading: false,
  getCaskMasterListData: null,
  getCaskMasterListError: null,
};

const getCaskMasterList = createAsyncThunk(
  "caskmaster/caskMasterList",
  async (payload) => {
    return await caskMasterService.getCaskMasterList(payload);
  },
);

const getCaskMasterListReducer = createSlice({
  name: "getCaskMasterList",
  initialState: getCaskMasterListState,
  extraReducers: (builder) => {
    builder.addCase(getCaskMasterList.pending, (state) => {
      state.getCaskMasterListLoading = true;
    });
    builder.addCase(getCaskMasterList.fulfilled, (state, action) => {
      state.getCaskMasterListLoading = false;
      state.getCaskMasterListData = action.payload;
      state.getCaskMasterListError = "";
    });
    builder.addCase(getCaskMasterList.rejected, (state, action) => {
      state.getCaskMasterListLoading = false;
      state.getCaskMasterListData = null;
      state.getCaskMasterListError = action.error.message;
    });
  },
});

export const GetCaskMasterListReducer = getCaskMasterListReducer.reducer;
export const GetCaskMasterList = getCaskMasterList;
// Get CaskMaster List End
